import classNames from "classnames";
import {useTranslation} from "react-i18next";
import {shallowEqual, useSelector} from "react-redux";
import {memo, useCallback, useMemo} from "react";
import {ACTIVE_COLOR, authTabConfig, INACTIVE_COLOR, selectUser, tabsConfig, userTabConfig} from "./helpers";
import {CONSTANTS} from "../../constants/constants";
import {ImageContainer} from "../ImageContainer/ImageContainer";
import {MobileNavItemHoc} from "./MobileNavItem/MobileNavItemHoc";
import s from './MobileNav.module.css';

export const MobileNav = memo(({pathname}) => {

  const {NAMESPACES, ROUTES} = CONSTANTS;

  const {t} = useTranslation(NAMESPACES.COMMON);

  const {isAuth, language} = useSelector(selectUser, shallowEqual);
  const dataPeople = useSelector(state => state.user.dataPeople);

  const finalTabs = useMemo(() => {
    const lastTab = isAuth
      ? {
          ...userTabConfig,
          isImage: true,
          image: dataPeople?.image || null,
          title: dataPeople?.firstName || 'account',
        }
      : authTabConfig;

    return [...tabsConfig, lastTab];
  }, [isAuth, dataPeople]);

  const activeTabIndex = useMemo(
    () => finalTabs?.findIndex(tab => tab?.paths?.some(path => path === pathname)),
    [finalTabs, pathname]
  );

  const transform = useMemo(
    () => (language?.isRTL ? ((finalTabs?.length - 1) - activeTabIndex) * 100 : activeTabIndex * 100),
    [language, activeTabIndex, finalTabs]
  );

  const renderTabItem = useCallback((item, index) => {
    const isActive = item?.paths?.includes(pathname);
    const activeColor = isActive ? ACTIVE_COLOR : INACTIVE_COLOR;

    return (
      <MobileNavItemHoc
        key={index}
        className={s.item}
        to={item?.link}
      >
        {item?.isImage && (
          <div
            className={classNames(
              s.image,
              {'loading-fon': !item?.image},
              {[s['image-active']]: isActive},
            )}
          >
            <ImageContainer id={item?.image} aspectRatio={'1/1'} />
          </div>
        )}
        {(!item?.isImage && !!item?.icon) && item?.icon(activeColor)}
        <p style={{color: activeColor}}>{t(item?.title)}</p>
      </MobileNavItemHoc>
    );
  }, [t, pathname]);

  const memoizedTabItems = useMemo(
    () => finalTabs.map(renderTabItem),
    [finalTabs, renderTabItem]
  );

  return (
    <nav
      className={s.wrapper}
      style={{gridTemplateColumns: `repeat(${finalTabs?.length ?? 4}, 1fr)`}}
    >
      {(pathname !== ROUTES.HOME.path) && (
        <div
          className={s.long}
          style={{
            left: 0,
            transform: `translateX(${transform}%)`,
            width: `${100 / finalTabs.length}%`
          }}
        />
      )}
      {memoizedTabItems}
    </nav>
  )
});